/* Diamond Studio — trust + booking layer (2026-10-10).
   Settings come from snippets/ds-trust-booking.liquid (window.DS_BOOKING).
   1. Any [data-ds-book] element opens the Calendly booking calendar in a popup
      (falls back to the Calendly page if the popup can't load).
   2. Product page: "Book a video call" beside "Make your best offer", the owners' card
      (Amit, Stefano, Shimi) under the buttons, and "Ask an owner" with their photos in the
      phone sticky bar (the small consultation link is hidden; the card replaces it).
      U.S. shoppers: the Affirm monthly price follows the selected options and stays
      directly under the price on phones too.
   3. Homepage: the "Request a consultation" link books a call; New York studio strip
      with Get directions right under the hero.
   4. Meta events, only with marketing consent and only once per action:
      Schedule (call booked), Lead (live offer sent), Contact (call / text tapped). */
(() => {
  'use strict';
  if (window.DSTrustBooking) return;
  const cfg = window.DS_BOOKING || {};
  if (!cfg.url) return;
  const doc = document;
  const CAL_ORIGIN = 'https://calendly.com';
  const OFFER_ORIGIN = cfg.offerOrigin || 'https://diamond-studio-offers.doijewelstrade.chatgpt.site';

  const ICON = {
    cal: '<svg class="ds-tb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3.5" y="5" width="17" height="15.5" rx="1.5"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/></svg>',
    video: '<svg class="ds-tb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="6.5" width="12.5" height="11" rx="1.5"/><path d="m15.5 10.5 5-3v9l-5-3"/></svg>',
    phone: '<svg class="ds-tb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5.5 3.5h3l1.8 4.6-2.2 1.4a11 11 0 0 0 6.4 6.4l1.4-2.2 4.6 1.8v3a2 2 0 0 1-2 2A16.5 16.5 0 0 1 3.5 5.5a2 2 0 0 1 2-2z"/></svg>',
    pin: '<svg class="ds-tb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 21s-6.5-6.2-6.5-11a6.5 6.5 0 0 1 13 0c0 4.8-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/></svg>',
    shield: '<svg class="ds-tb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.2-7.5 9.5-4.3-1.3-7.5-4.9-7.5-9.5V6z"/><path d="M8.8 12l2.3 2.3 4.2-4.6"/></svg>',
    star: '<svg class="ds-tb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.6l1-5.8L3.5 9.7l5.9-.9z"/></svg>',
    arrow: '<svg class="ds-tb-i ds-tb-i--arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>'
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const tel = 'tel:' + cfg.phone;
  const sms = 'sms:' + cfg.phone;

  /* ---------- consent-aware measurement ---------- */
  function consent(kind) {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      const fn = cp && (kind === 'marketing' ? cp.marketingAllowed : cp.analyticsProcessingAllowed);
      if (typeof fn === 'function') return fn.call(cp) !== false;
    } catch (e) { /* fall through */ }
    return true; // no consent API on the page: the pixel's own loader decides
  }
  function once(key) {
    try {
      const list = JSON.parse(sessionStorage.getItem('ds-tb-sent') || '[]');
      if (list.indexOf(key) !== -1) return false;
      list.push(key);
      sessionStorage.setItem('ds-tb-sent', JSON.stringify(list.slice(-60)));
    } catch (e) { /* storage blocked: still send once for this page view */ }
    if (once.mem[key]) return false;
    once.mem[key] = 1;
    return true;
  }
  once.mem = {};
  function meta(name, params, eventId) {
    if (!consent('marketing') || typeof window.fbq !== 'function') return false;
    try {
      if (eventId) window.fbq('track', name, params || {}, {eventID: eventId});
      else window.fbq('track', name, params || {});
      return true;
    } catch (e) { return false; }
  }
  function note(eventName, data) {
    const payload = Object.assign({placement: 'site'}, data || {});
    if (consent('analytics')) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({event: eventName}, payload)); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', eventName); } catch (e) {}
    }
    // Shopify customer events (custom web pixels can subscribe to these names).
    try { window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function' && window.Shopify.analytics.publish(eventName, payload); } catch (e) {}
  }
  function productInfo() {
    let id = '', title = cfg.product || '', options = '';
    try {
      const sel = typeof window.DS_PRODUCT_SELECTION === 'function' ? window.DS_PRODUCT_SELECTION() : null;
      if (sel) {
        id = sel.productId ? String(sel.productId) : '';
        const bits = [sel.gold, sel.ringSize ? 'size ' + sel.ringSize : ''].filter(Boolean);
        options = bits.join(', ');
      }
    } catch (e) { /* options not ready */ }
    return {id, title, options};
  }

  /* ---------- Calendly ---------- */
  let calendlyLoad = null;
  let lastPlacement = 'site';
  function loadCalendly() {
    if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') return Promise.resolve();
    if (calendlyLoad) return calendlyLoad;
    calendlyLoad = new Promise((resolve, reject) => {
      if (!doc.querySelector('link[data-ds-calendly]')) {
        const link = doc.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        link.setAttribute('data-ds-calendly', '');
        doc.head.appendChild(link);
      }
      const script = doc.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      const timer = setTimeout(() => { calendlyLoad = null; reject(new Error('timeout')); }, 9000);
      script.onload = () => { clearTimeout(timer); window.Calendly && typeof window.Calendly.initPopupWidget === 'function' ? resolve() : reject(new Error('no widget')); };
      script.onerror = () => { clearTimeout(timer); calendlyLoad = null; reject(new Error('blocked')); };
      doc.head.appendChild(script);
    });
    return calendlyLoad;
  }
  function bookingUrl(placement) {
    const url = new URL(cfg.url);
    url.searchParams.set('utm_source', 'diamondstudio.com');
    url.searchParams.set('utm_medium', 'website');
    url.searchParams.set('utm_campaign', 'book_a_call');
    url.searchParams.set('utm_content', placement || 'site');
    if (cfg.template === 'product') {
      const p = productInfo();
      if (p.title) url.searchParams.set('a1', 'I am interested in: ' + p.title + (p.options ? ' (' + p.options + ')' : ''));
    }
    return url.toString();
  }
  function openBooking(placement) {
    lastPlacement = placement || 'site';
    const url = bookingUrl(lastPlacement);
    note('ds_booking_open', {placement: lastPlacement});
    loadCalendly()
      .then(() => window.Calendly.initPopupWidget({url}))
      .catch(() => { window.location.href = url; });
  }
  doc.addEventListener('click', event => {
    const trigger = event.target.closest && event.target.closest('[data-ds-book]');
    if (trigger) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return; // let "open in new tab" work
      event.preventDefault();
      openBooking(trigger.getAttribute('data-ds-book'));
      return;
    }
    const contact = event.target.closest && event.target.closest('a[href^="tel:"], a[href^="sms:"]');
    if (contact) {
      const method = contact.getAttribute('href').indexOf('sms:') === 0 ? 'text' : 'call';
      const placement = contact.getAttribute('data-ds-phone') || 'site';
      note('ds_phone_' + method, {placement});
      if (once('contact_' + method)) meta('Contact', {content_name: method === 'text' ? 'Text the studio' : 'Call the studio', content_category: placement});
    }
  });
  // Warm up the calendar when a shopper is about to book.
  const warm = event => { if (event.target.closest && event.target.closest('[data-ds-book]')) loadCalendly().catch(() => {}); };
  doc.addEventListener('pointerover', warm, {passive: true});
  doc.addEventListener('focusin', warm);
  doc.addEventListener('touchstart', warm, {passive: true});

  window.addEventListener('message', event => {
    const data = event.data;
    if (!data || typeof data !== 'object') return;
    if (event.origin === CAL_ORIGIN && data.event === 'calendly.event_scheduled') {
      const payload = data.payload || {};
      const uri = (payload.invitee && payload.invitee.uri) || (payload.event && payload.event.uri) || String(Date.now());
      const key = 'book_' + String(uri).split('/').pop().slice(0, 60);
      if (!once(key)) return;
      const p = productInfo();
      const params = {content_name: 'Diamond Studio consultation', content_category: lastPlacement};
      if (p.id) { params.content_ids = [p.id]; params.content_type = 'product'; }
      meta('Schedule', params, key);
      note('ds_call_booked', {placement: lastPlacement});
      return;
    }
    if (event.origin === OFFER_ORIGIN && data.type === 'diamond-studio-offer:submitted' && data.schemaVersion === 1 && data.mode === 'live' && /^[a-f0-9]{64}$/.test(data.eventId || '')) {
      const key = 'offer_' + data.eventId.slice(0, 40);
      if (!once(key)) return;
      const p = productInfo();
      const params = {content_name: 'Make your best offer', content_category: 'offer'};
      if (p.id) { params.content_ids = [p.id]; params.content_type = 'product'; }
      meta('Lead', params, key);
      note('ds_offer_sent', {placement: cfg.template === 'product' ? 'product' : 'collection'});
    }
  });

  /* ---------- product page ---------- */
  function bookLink(placement, className, label) {
    const a = doc.createElement('a');
    a.href = cfg.url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = className;
    a.setAttribute('data-ds-book', placement);
    a.innerHTML = ICON.video + '<span>' + esc(label) + '</span>' + ICON.arrow;
    return a;
  }
  function mountProduct() {
    const offer = doc.getElementById('best-offer-button');
    if (offer && !doc.querySelector('[data-ds-book="product"]')) {
      const actions = offer.parentElement;
      const book = bookLink('product', 'ds-tb-pdp-book', 'Book a video call');
      book.setAttribute('aria-label', 'Book a video or phone call with the Diamond Studio team');
      offer.after(book);
      if (actions) actions.classList.add('ds-tb-pdp-actions');
    }
    const sticky = doc.querySelector('.a-sticky-buy');
    if (sticky && !sticky.querySelector('[data-ds-book]')) {
      const book = owners ? stickyOwners() : bookLink('product_sticky', 'ds-tb-sticky-book', 'Book a call');
      if (!owners) book.setAttribute('aria-label', 'Book a video or phone call with the Diamond Studio team');
      sticky.appendChild(book);
      sticky.classList.add('ds-tb-has-book');
    }
    const consult = doc.querySelector('#ds-cro-purchase [data-ds-consult]');
    if (consult && !consult.hasAttribute('data-ds-tb')) {
      consult.setAttribute('data-ds-tb', '');
      consult.hidden = true;
      if (!owners) { // the owners' card already offers call, text and booking
        const talk = doc.createElement('p');
        talk.className = 'ds-tb-pdp-talk';
        talk.innerHTML = ICON.phone + '<span>Talk to a real person: call or text <a href="' + tel + '" data-ds-phone="product">' + esc(cfg.phoneDisplay) + '</a> or <a href="' + esc(cfg.url) + '" target="_blank" rel="noopener" data-ds-book="product_talk">book a video call</a>.</span>';
        consult.after(talk);
      }
    }
    mountOwners();
    placePayment();
    syncAffirm();
  }

  /* Owners' card (2026-10-11): the three owners right under the buy buttons, with the store rating,
     the studio address and a direct line. Data: window.DS_BOOKING.owners (snippets/ds-trust-booking.liquid). */
  const owners = cfg.owners && Array.isArray(cfg.owners.people) && cfg.owners.people.length ? cfg.owners : null;
  function faces(size, alt) {
    return owners.people.map(p => '<img src="' + esc(p.img) + '" alt="' + (alt ? esc(p.name) : '') + '" width="' + size + '" height="' + size + '" loading="lazy" decoding="async">').join('');
  }
  function ownerNames() {
    const names = owners.people.map(p => p.name);
    return names.length > 1 ? names.slice(0, -1).join(', ') + ' &amp; ' + names[names.length - 1] : names[0];
  }
  function mountOwners() {
    if (!owners || doc.querySelector('.ds-tb-owners')) return;
    const actions = doc.getElementById('buy-actions');
    if (!actions || !actions.parentNode) return;
    // Keep "Secure, encrypted checkout" attached to the buttons; the card goes right after it.
    const next = actions.nextElementSibling;
    const anchor = next && next.classList.contains('ds-pt') ? next : actions;
    const noun = /\b(rings?|bands?)\b/i.test((owners.productType || '') + ' ' + (cfg.product || '')) ? 'ring' : 'piece';
    const rating = Number(owners.rating);
    const count = parseInt(owners.reviews, 10);
    const facts = [ICON.shield + '<span>Lifetime warranty</span>'];
    if (rating > 0 && count > 0) facts.push(ICON.star + '<span>' + rating.toFixed(1) + ' · ' + count + ' review' + (count === 1 ? '' : 's') + '</span>');
    facts.push(ICON.pin + '<a href="' + esc(cfg.mapsUrl) + '" target="_blank" rel="noopener">580 Fifth Ave, NYC</a>');
    const card = doc.createElement('aside');
    card.className = 'ds-tb-owners';
    card.setAttribute('aria-labelledby', 'ds-tb-owners-title');
    card.innerHTML =
      '<div class="ds-tb-owners__head">' +
        '<div class="ds-tb-owners__faces">' + faces(50, true) + '</div>' +
        '<div class="ds-tb-owners__heading"><p class="ds-tb-owners__eyebrow">The owners · New York</p>' +
        '<p class="ds-tb-owners__title" id="ds-tb-owners-title">You’re buying from ' + ownerNames() + '.</p></div>' +
      '</div>' +
      '<p class="ds-tb-owners__text">Three generations in diamonds, from our studio on Fifth Avenue. Your ' + noun + ' is made new for you and checked before it ships, and you can talk to one of us before you decide.</p>' +
      '<ul class="ds-tb-owners__facts">' + facts.map(f => '<li>' + f + '</li>').join('') + '</ul>' +
      '<div class="ds-tb-owners__links">' +
        '<a href="' + tel + '" data-ds-phone="product_owners" aria-label="Call or text ' + esc(cfg.phoneDisplay) + '">' + ICON.phone + '<span>Call or text <span class="ds-tb-owners__num">' + esc(cfg.phoneDisplay) + '</span><span class="ds-tb-owners__us">us</span></span></a>' +
        '<a href="' + esc(owners.aboutUrl || '/pages/diamond-studio-story') + '"><span>Meet the owners</span>' + ICON.arrow + '</a>' +
      '</div>';
    anchor.after(card);
  }
  function stickyOwners() {
    const a = doc.createElement('a');
    a.href = cfg.url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = 'ds-tb-sticky-book ds-tb-sticky-owners';
    a.setAttribute('data-ds-book', 'product_sticky');
    a.setAttribute('aria-label', 'Ask an owner: book a video or phone call with Amit, Stefano or Shimi');
    a.innerHTML = '<span class="ds-tb-sticky-owners__faces">' + faces(22, false) + '</span><span class="ds-tb-sticky-owners__label">Ask an owner</span>';
    return a;
  }
  // Keep the payment line (Affirm monthly price for U.S. shoppers) right under the price,
  // including on phones where the price is moved above the photos.
  function placePayment() {
    const payment = doc.querySelector('.ds-payment-product-price');
    const price = doc.querySelector('#product .a-price-row');
    if (!payment || !price || !price.parentNode) return;
    if (price.nextElementSibling !== payment) price.after(payment);
  }
  let affirmTimer = 0;
  function syncAffirm() {
    const finance = doc.getElementById('ds-preview-affirm');
    if (!finance || typeof window.DS_PRODUCT_SELECTION !== 'function') return;
    let cents = 0;
    try { cents = window.DS_PRODUCT_SELECTION().priceCents; } catch (e) { return; }
    if (!Number.isSafeInteger(cents) || cents <= 0 || finance.getAttribute('data-amount') === String(cents)) return;
    finance.setAttribute('data-amount', String(cents));
    clearTimeout(affirmTimer);
    affirmTimer = setTimeout(() => {
      try { window.affirm && window.affirm.ui && window.affirm.ui.ready(() => window.affirm.ui.refresh()); } catch (e) {}
    }, 250);
  }

  /* ---------- homepage ---------- */
  function mountHome() {
    const hero = doc.getElementById('hero');
    if (hero && !doc.querySelector('.ds-tb-studio')) {
      const strip = doc.createElement('section');
      strip.className = 'ds-tb-studio';
      strip.setAttribute('aria-label', 'Our New York studio');
      strip.innerHTML =
        '<div class="ds-tb-studio__place">' + ICON.pin + '<div><strong>Our New York studio</strong><address>' + esc(cfg.address) + '</address><span>By appointment · Video and phone consultations</span></div></div>' +
        '<div class="ds-tb-studio__actions">' +
          '<a class="ds-tb-studio__book" href="' + esc(cfg.url) + '" target="_blank" rel="noopener" data-ds-book="home_studio">' + ICON.cal + '<span>Book appointment</span></a>' +
          '<a class="ds-tb-studio__link" href="' + tel + '" data-ds-phone="home_studio">' + ICON.phone + '<span>' + esc(cfg.phoneDisplay) + '</span></a>' +
          '<a class="ds-tb-studio__link" href="' + esc(cfg.mapsUrl) + '" target="_blank" rel="noopener">' + ICON.pin + '<span>Get directions</span></a>' +
        '</div>';
      hero.after(strip);
    }
    doc.querySelectorAll('.store-services a').forEach(a => {
      if (a.hasAttribute('data-ds-book') || !/consultation/i.test(a.textContent)) return;
      a.setAttribute('data-ds-book', 'home_services');
      a.setAttribute('href', cfg.url);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      // Only swap the "Request a consultation" line; keep the icon and "A little expert guidance" title.
      const walker = doc.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (/request a consultation/i.test(node.textContent)) node.textContent = node.textContent.replace(/request a consultation/i, 'Book a video call');
      }
    });
  }

  /* ---------- run + keep in place when the page scripts re-render ---------- */
  let queued = false;
  function mount() {
    queued = false;
    try {
      if (cfg.template === 'product') mountProduct();
      if (cfg.template === 'index') mountHome();
    } catch (e) { /* never break the page */ }
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(mount); } }
  if (cfg.template === 'product' || cfg.template === 'index') {
    new MutationObserver(queue).observe(doc.body, {childList: true, subtree: true});
    doc.addEventListener('change', () => setTimeout(syncAffirm, 60), true);
    doc.addEventListener('click', () => setTimeout(syncAffirm, 120), true);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mount); else mount();

  window.DSTrustBooking = {open: openBooking, url: bookingUrl};
})();
